<template>
    <div class="card-owner-data-container">
        <div class="content-container">
            <div class="personal-data-wrapper">
                <h1>Fahrkarteninhaberdaten ändern</h1>

                <EditPersonalData :customer="customer" @submit="handleSubmit"/>
            </div>
        </div>

        <PopUp title="Datenänderung beantragen" :open="showAreYouSure" submit-label="Beantragen" cancel-label="Abbrechen" @close="handleClose">
            <label>Ihre Änderungen werden beantragt. Nach dem Absenden kann es einige Tage dauern, bis Ihre Daten geprüft und aktualisiert werden.</label>
        </PopUp>
    </div>
</template>

<script>
import axios from 'axios'

import PopUp from '@elements/PopUp.vue'
import EditPersonalData from '@components/EditPersonalData.vue'

export default {
    name: 'card-owner-data-page',
    inject: [ 'util', 'globalState', 'toast'],
    data() {
        return {
            customer: {},
            submitCustomer: undefined,
            showAreYouSure: false
        }
    },
    mounted() {
        this.init()
    },
    computed: {
        customerId() {
            return encodeURIComponent(this.$route.params.id)
        }
    },
    methods: {
        init() {
            this.globalState.isLoading = true

            let getCardOwnerUrl = this.util.middleware()
            getCardOwnerUrl += '/card-owners/' + this.customerId

            axios.get(getCardOwnerUrl)
            .then(response => {
                this.customer = response.data
                this.globalState.isLoading = false
            })
            .catch(() => {
                const errorMessage = this.$t('general.error')
                this.toast.error(errorMessage) 
            })
        },
        handleSubmit(event) {
            console.log(event)

            if (event) {
                this.submitCustomer = event
                this.showAreYouSure = true
            }
        },
        handleClose(event) {
            if (event) {
                this.globalState.isLoading = true

                let requestChangesUrl = this.util.middleware()
                requestChangesUrl += '/card-owners/' + this.submitCustomer.id

                axios.put(requestChangesUrl, this.submitCustomer)
                .then(response => {
                    console.log(response)
                    this.submitCustomer = undefined
                    this.showAreYouSure = false
                    this.globalState.isLoading = false
                    this.$router.push('/')
                })
                .catch(() => {
                    this.showAreYouSure = false
                    this.submitCustomer = undefined
                    const errorMessage = this.$t('general.error')
                    this.toast.error(errorMessage) 
                })
            } else {
                this.submitCustomer = undefined
                this.showAreYouSure = false
            }
        }
    },
    components: {
        EditPersonalData,
        PopUp
    }
}
</script>

<style lang="scss" scoped>
.card-owner-data-container {
    width: 100%;
}

.personal-data-wrapper {
    background-color: #fff;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 2px 8px #00000022;

    > h1 {
        margin: 0;
    }

    > div {
        margin-top: 40px;
    }
}
</style>